//Action types
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import {
  createStripeSubscription,
  getStripeSubscriptionStatus,
  // getSubscriptionPrice,
  onOrganizationCollectionCreate,
  onOrganizationCollectionFind,
  onOrganizationCollectionUpdate,
} from '../../util/api';
import { storableError } from '../../util/errors';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';


export const FETCH_SUBSCRIPTION_PRICE_REQUEST = 'app/StripeSubscriptionPage/FETCH_SUBSCRIPTION_PRICE_REQUEST';
export const FETCH_SUBSCRIPTION_PRICE_SUCCESS = 'app/StripeSubscriptionPage/FETCH_SUBSCRIPTION_PRICE_SUCCESS';
export const FETCH_SUBSCRIPTION_PRICE_ERROR = 'app/StripeSubscriptionPage/FETCH_SUBSCRIPTION_PRICE_ERROR';
export const FETCH_SUBSCRIPTIONS_REQUEST = 'app/StripeSubscriptionPage/FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'app/StripeSubscriptionPage/FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_ERROR = 'app/StripeSubscriptionPage/FETCH_SUBSCRIPTIONS_ERROR';
export const CHANGE_SUBSCRIPTION_REQUEST = 'app/StripeSubscriptionPage/CHANGE_SUBSCRIPTION_REQUEST';
export const CHANGE_SUBSCRIPTION_SUCCESS = 'app/StripeSubscriptionPage/CHANGE_SUBSCRIPTION_SUCCESS';
export const CHANGE_SUBSCRIPTION_ERROR = 'app/StripeSubscriptionPage/CHANGE_SUBSCRIPTION_ERROR';
export const FETCH_SUBSCRIPTIONS_LOAD_DATA = 'app/StripeSubscriptionPage/FETCH_SUBSCRIPTIONS_LOAD_DATA';

export const FETCH_ORGANIZATION_REQUEST = 'app/StripeSubscriptionPage/FETCH_ORGANIZATION_REQUEST';
export const FETCH_ORGANIZATION_SUCCESS = 'app/StripeSubscriptionPage/FETCH_ORGANIZATION_SUCCESS';
export const FETCH_ORGANIZATION_ERROR = 'app/StripeSubscriptionPage/FETCH_ORGANIZATION_ERROR';

const initialState = {
  changeSubscriptionInProgess: false,
  changeSubscriptionError: null,
  subscriptionLoadDataRequest: false,
  subscriptionPlan: null,
  fetchPriceInProgress: false,
  fetchPriceError: null,
  userSubscriptions: [],
  fetchSubscriptionInProgress: false,
  fetchSubscriptionError: null,
  fetchOrganizationRequest: false,
  organizations: null,
  fetchOrganizationError: null,
};

//Selectors
export const checkScrollingDisabled = state => isScrollingDisabled(state);
//reducer function
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CHANGE_SUBSCRIPTION_REQUEST:
      return { ...state, changeSubscriptionInProgess: payload, changeSubscriptionError: null };
    case CHANGE_SUBSCRIPTION_SUCCESS:
      return { ...state, changeSubscriptionInProgess: false, changeSubscriptionError: null }
    case CHANGE_SUBSCRIPTION_ERROR:
      return { ...state, changeSubscriptionInProgess: false, changeSubscriptionError: payload }
    case FETCH_SUBSCRIPTION_PRICE_REQUEST:
      return { ...state, fetchPriceInProgress: true, fetchPriceError: null };
    case FETCH_SUBSCRIPTION_PRICE_SUCCESS:
      return {
        ...state,
        subscriptionPlan: payload,
        fetchPriceInProgress: false,
        fetchPriceError: null,
      };
    case FETCH_SUBSCRIPTION_PRICE_ERROR:
      return { ...state, fetchPriceInProgress: false, fetchPriceError: payload };
    case FETCH_SUBSCRIPTIONS_REQUEST:
      return { ...state, fetchSubscriptionInProgress: true, fetchSubscriptionError: null };
    case FETCH_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        userSubscriptions: payload,
        fetchSubscriptionInProgress: false,
        fetchSubscriptionError: null,
      };
    case FETCH_SUBSCRIPTIONS_ERROR:
      return { ...state, fetchSubscriptionInProgress: false, fetchSubscriptionError: payload };
    case FETCH_SUBSCRIPTIONS_LOAD_DATA:
      return { ...state, subscriptionLoadDataRequest: payload }

    case FETCH_ORGANIZATION_REQUEST:
      return {
        ...state,
        fetchOrganizationRequest: true,
        organizations: null,
        fetchOrganizationError: null
      };
    case FETCH_ORGANIZATION_SUCCESS:
      return {
        ...state,
        fetchOrganizationRequest: false,
        organizations: payload,
        fetchOrganizationError: null
      }
    case FETCH_ORGANIZATION_ERROR:
      return {
        ...state,
        fetchOrganizationRequest: false,
        organizations: null,
        fetchOrganizationError: true
      }

    default:
      return state;
  }
}
// ================ Action creators ================ //
export const fetchPriceRequest = () => ({
  type: FETCH_SUBSCRIPTION_PRICE_REQUEST,
});
export const fetchPriceSuccess = data => ({
  type: FETCH_SUBSCRIPTION_PRICE_SUCCESS,
  payload: data,
});
export const fetchPriceError = e => ({
  type: FETCH_SUBSCRIPTION_PRICE_ERROR,
  error: true,
  payload: e,
});
export const fetchSubscriptionsRequest = () => ({
  type: FETCH_SUBSCRIPTIONS_REQUEST,
});
export const fetchSubscriptionsSuccess = data => ({
  type: FETCH_SUBSCRIPTIONS_SUCCESS,
  payload: data,
});
export const fetchSubscriptionsError = e => ({
  type: FETCH_SUBSCRIPTIONS_ERROR,
  error: true,
  payload: e,
});
export const changeSubscriptionRequest = (type) => ({
  type: CHANGE_SUBSCRIPTION_REQUEST,
  payload: type,
});
export const changeSubscriptionSuccess = () => ({
  type: CHANGE_SUBSCRIPTION_SUCCESS,
});
export const changeSubscriptionError = e => ({
  type: CHANGE_SUBSCRIPTION_ERROR,
  error: true,
  payload: e,
});
export const subscriptionLoadDataRequest = (data) => ({
  type: FETCH_SUBSCRIPTIONS_LOAD_DATA,
  payload: data,
});


export const organizationCollectionRequest = () => ({
  type: FETCH_ORGANIZATION_REQUEST,
});
export const organizationCollectionSuccess = (data) => ({
  type: FETCH_ORGANIZATION_SUCCESS,
  payload: data
});
export const organizationCollectionError = e => ({
  type: FETCH_ORGANIZATION_ERROR,
  error: true,
  payload: e,
});

// ================ Thunk ================ //
export const fetchPriceFromStripe = () => async (dispatch, getState, sdk) => {
  // dispatch(fetchPriceRequest());
  // return getSubscriptionPrice({ tab: "price" })
  //   .then((response) => {
  //     dispatch(fetchPriceSuccess(response));
  //   })
  //   .catch(e => {
  //     dispatch(fetchPriceError(storableError(error)));
  //   })
};
//Create subscription with Stripe
export const createSubscription = params => async (dispatch, getState, sdk) => {
  try {
    const subscription = await createStripeSubscription(params);
    return subscription;
  } catch (error) {
    console.error(error, 'error');
  }
};
// Get subscriptions
export const getSubscriptions = () => async (dispatch, getState, sdk) => {
  dispatch(fetchSubscriptionsRequest());
  try {
    const subscriptions = await getStripeSubscriptionStatus({});
    dispatch(fetchSubscriptionsSuccess(subscriptions));
    return subscriptions;
  } catch (error) {
    dispatch(fetchSubscriptionsError(storableError(error)));
    console.error(error, 'error');
  }
};

export const organizationCollections = (params) => async (dispatch, sdk, getState) => {
  dispatch(organizationCollectionRequest());
  return onOrganizationCollectionFind(params)
    .then((response) => {
      dispatch(organizationCollectionSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(organizationCollectionError());
    })
};

export const changeSubcription = params => async (dispatch, sdk, getState) => {
  try {
    const { changedUserRole } = params || {}
    dispatch(changeSubscriptionRequest(changedUserRole));
    const valueToUpdate = {
      publicData: { userRole: changedUserRole }
    };
    dispatch(updateProfile(valueToUpdate)).then(_ => {
      console.log('Then running!')
      dispatch(changeSubscriptionSuccess());
    })
  } catch (e) {
    dispatch(changeSubscriptionError(e));
    console.log(e, 'error');
  }
}
//LoadData
export const loadData = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(subscriptionLoadDataRequest(true));
    const organizationParams = {
      payload: {
        isDelete: false
      }
    }
    return Promise.all([
      dispatch(fetchCurrentUser()),
      // dispatch(fetchPriceFromStripe()),
      dispatch(organizationCollections(organizationParams))
    ]).then(async (response) => {
      const currentUser = getState().user?.currentUser;
      const stripeCustomerId = currentUser?.attributes?.profile?.protectedData?.stripeCustomerId;
      if (stripeCustomerId) {
        await dispatch(getSubscriptions());
      }
      dispatch(subscriptionLoadDataRequest(false));
    })
  }
  catch (e) {
    dispatch(subscriptionLoadDataRequest(false));
  }
};
